import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CatIcon } from "@/lib/categories";
import { JobCard } from "@/components/JobCard";
import { Button } from "@/components/ui/button";
import { Loader2, FileText, Search } from "lucide-react";

export default function CategoryPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [cat, setCat] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [ustalar, setUstalar] = useState([]);

  useEffect(() => {
    api.get(`/categories/${slug}`).then(({ data }) => setCat(data)).catch(() => {});
    api.get(`/jobs?category=${slug}&limit=6`).then(({ data }) => setJobs(data.items)).catch(() => {});
    api.get(`/ustalar?category=${slug}&limit=4`).then(({ data }) => setUstalar(data.items)).catch(() => {});
  }, [slug]);

  if (!cat) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-emerald-500" /></div>;

  return (
    <div>
      <div className="tinted border-b border-emerald-100">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="flex items-center gap-2 text-sm text-slate-500 mb-4"><Link to="/" className="hover:text-emerald-600">Ana Sayfa</Link> / <span className="text-slate-700">{cat.name}</span></div>
          <span className="inline-flex items-center gap-2 h-11 px-4 rounded-full bg-white text-emerald-600 font-semibold shadow-sm"><CatIcon name={cat.icon} className="h-5 w-5" /> {cat.name}</span>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-4 max-w-2xl">{cat.name} için doğru ustayı bul</h1>
          <p className="text-slate-600 mt-3 max-w-2xl">{cat.description}</p>
          <div className="flex flex-col sm:flex-row gap-3 mt-6">
            <Button onClick={() => navigate("/ilan-ver")} className="brand-gradient text-white rounded-xl h-11 px-6" data-testid="category-post-job"><FileText className="h-4 w-4 mr-1.5" /> İş İlanı Ver</Button>
            <Button onClick={() => navigate(`/ilanlar?category=${slug}`)} variant="outline" className="rounded-xl h-11 px-6 border-emerald-200 text-emerald-700" data-testid="category-browse-jobs"><Search className="h-4 w-4 mr-1.5" /> İlanları İncele</Button>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex items-center justify-between mb-5"><h2 className="text-2xl font-bold text-slate-900">İlgili İlanlar</h2><Link to={`/ilanlar?category=${slug}`} className="text-sm text-emerald-600 font-semibold">Tümü →</Link></div>
        {jobs.length === 0 ? <p className="text-slate-400 text-sm">Bu kategoride henüz ilan yok.</p> : <div className="space-y-4">{jobs.map((j) => <JobCard key={j.id} job={j} />)}</div>}

        {ustalar.length > 0 && (<>
          <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-5">İlgili Ustalar</h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {ustalar.map((u) => (
              <Link key={u.user_id} to={`/usta/${u.user_id}`} className="bg-white rounded-2xl border border-slate-200/80 overflow-hidden hover-lift">
                <div className="h-28 bg-slate-100">{u.avatar && <img src={u.avatar} alt={u.name} className="w-full h-full object-cover" />}</div>
                <div className="p-4"><div className="font-bold text-slate-900 text-sm">{u.name}</div><div className="text-xs text-slate-500">{u.specialty}</div></div>
              </Link>
            ))}
          </div>
        </>)}
      </div>
    </div>
  );
}
